import { AUTH_API_GW_URL } from '@/constants';
import store from '@/store';
import axios from 'axios';

const API = axios.create({
  baseURL: AUTH_API_GW_URL
});

export type ContactType = '' | 'phone' | 'email';

export type CRMContactType = {
  cont_type: ContactType;
  cont_value: string;
};

export const getCrmContacts = async (): Promise<CRMContactType[]> => {
  try {
    const response = await API.get<{ contacts: CRMContactType[] }>(
      '/crm/contacts',
      {
        headers: {
          Authorization: `Bearer ${store.getters.idToken}`
        }
      }
    );
    return response.data.contacts;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const sendOtpRequest = async (body: CRMContactType): Promise<void> => {
  await API.post(
    '/otp/generate',
    {
      ...body
    },
    {
      headers: {
        Authorization: `Bearer ${store.getters.idToken}`
      }
    }
  );
};

export const confirmOtpRequest = async (otpValue: string): Promise<void> => {
  await API.post(
    '/otp/validate',
    { otp_token: otpValue },
    {
      headers: {
        Authorization: `Bearer ${store.getters.idToken}`
      }
    }
  );
};
